import React from "react";
import { useNavigate } from "react-router-dom";
import "./PayoutTable.css";

const PayoutTable = ({ data, totalItems, currentPage, onPageChange }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "Paid";
      default:
        return "Unknown";
    }
  };

  const getExpertName = (expertId) => {
    // In a real app, you would fetch the expert name based on ID
    // For now just use a placeholder
    return `Expert Name`;
  };

  const handleViewDetails = (item) => {
    // Get the current date to extract month and year
    const billedDate = new Date(item.billed_date);
    const month = billedDate.getMonth() + 1; // JS months are 0-indexed
    const year = billedDate.getFullYear();

    // Navigate to the payout details page
    navigate(`/payout/${item.expert}/?month=${month}&year=${year}&page=1`);
  };

  const renderPagination = () => {
    const maxPages = Math.ceil(totalItems / 8);
    const pageNumbers = [];

    // Add first page and ellipsis if needed
    if (currentPage > 3) {
      pageNumbers.push(1);
      if (currentPage > 4) pageNumbers.push("...");
    }

    // Add pages around current page
    for (
      let i = Math.max(1, currentPage - 1);
      i <= Math.min(maxPages, currentPage + 1);
      i++
    ) {
      pageNumbers.push(i);
    }

    // Add ellipsis and last page if needed
    if (currentPage < maxPages - 2) {
      if (currentPage < maxPages - 3) pageNumbers.push("...");
      pageNumbers.push(maxPages);
    }

    return (
      <div className="pagination">
        <button
          className="pagination-arrow"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          &lt;
        </button>
        {pageNumbers.map((page, index) => (
          <button
            key={index}
            className={`pagination-number ${
              page === currentPage ? "active" : ""
            }`}
            onClick={() => typeof page === "number" && onPageChange(page)}
          >
            {page}
          </button>
        ))}
        <button
          className="pagination-arrow"
          disabled={currentPage === maxPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          &gt;
        </button>
      </div>
    );
  };

  return (
    <div className="payout-table-container">
      <table className="payout-table">
        <thead>
          <tr>
            <th>Expert</th>
            <th>Billed on</th>
            <th>Amount to be Paid</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td>{item.expert_name}</td>
              <td>{formatDate(item.billed_date)}</td>
              <td>{item.amount.toLocaleString()}</td>
              <td>
                <span
                  className={`status-badge status-${getStatusLabel(
                    item.payout_status
                  ).toLowerCase()}`}
                >
                  {getStatusLabel(item.payout_status)}
                </span>
              </td>
              <td>
                <button
                  className="view-details-btn"
                  onClick={() => handleViewDetails(item)}
                >
                  &gt;
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="table-footer">
        <div className="showing-entries">
          Showing data 1 to {Math.min(8, data.length)} of {totalItems} entries
        </div>
        {renderPagination()}
      </div>
    </div>
  );
};

export default PayoutTable;
